module.exports = __webpack_public_path__ + "static/img/image_solutions_precision_01.e524c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_precision_01.png
// module id = 5PEM
// module chunks = 10